import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Grid, TextField, Typography, Select, MenuItem, SelectChangeEvent, useTheme, } from '@mui/material'; // Import Select and MenuItem
import axios from 'axios';
import { DailyLogfields } from '../../constants/Dailylogfields';
import { DailyLog } from './Dailylogs';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, } from 'react-redux';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../theme/theme';
import SignatureCanvas from 'react-signature-canvas'; // Import SignatureCanvas
import { BASEURL, ARROW, SIGN_FONT, FONT_SIZE, AUTOFILL_STYLES } from "../../constants/Common"
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';


interface ProjectNames {
  id: number;
  project_name: string;
  project_status: string;
}


const CreateNewDailyLogPage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Define signatureRef using useRef hook
  const signatureRef = useRef<SignatureCanvas>(null);
  const [signatureData, setSignatureData] = useState('');
  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const location = useLocation();
  const [assignedUsers, setAssignedUsers] = useState<string[]>([]); // Users assigned to the selected project
  const [selectedProjectId, setSelectedProjectId] = useState<number | ''>('');
  const mergedListRef = useRef(0);

  const today = new Date().toISOString().slice(0, 10);
  const username = localStorage.getItem("username")
  const orgid = localStorage.getItem('orgid');
  const userid = localStorage.getItem('userid');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    // Call fetchProjectnamesList when the component mounts and when projectNamesData changes
    //fetchProjectnamesList()

    let argProjectNames = location?.state?.projectNameList;
    if (argProjectNames !== undefined) {
      setProjectNamesData(argProjectNames);
    }
    if (mergedListRef.current === 0) {  //use this condition to fetch and populate list only one time
      fetchAssignedUsers(selectedProjectId);
      mergedListRef.current = 1
    }

  }, []);


  const [newLog, setNewLog] = useState<DailyLog>({
    id: null,
    assignedto: '',
    createddate: today,
    projectcode: '',
    status: '',
    title: '',
    description: '',
    createdby: username ? username : '',
    remarks: '',
    projectname: '',
    attachments: null,
    attachments2: null,
    attachments3: null,
    attachments4: null,
    attachments5: null,
    attachments6: null,

    project_id: '',
    signature: '',
    initials: '',
  });

  const fetchAssignedUsers = async (projectId: any) => {
    try {
      const response = await axios.get(`${BASEURL}/api/assignedusers/${projectId}/?orgid=${orgid}&userid=${userid}`,
        {
          headers: { 'Content-Type': 'multipart/form-data', },
        }
      );
      if (response.status === 200) {
        const assignedUsersList = response.data.users;
        setAssignedUsers(assignedUsersList.map((user: any) => user.username));
        console.log(assignedUsers)
      }
    } catch (error) {
      console.error('Error fetching assigned users:', error);
    }
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent<string>
  ) => {
    if (event.target.name === "projectname") {
      const valueProjectID = parseInt(event.target.value);

      const selProjectNameArray = projectNamesData.find(project => project.id === valueProjectID);
      if (selProjectNameArray) {
        const selProjectName = selProjectNameArray.project_name;

        setNewLog((prevState) => ({
          ...prevState!,
          projectname: selProjectName,
          project_id: event.target.value
        }));

        // Fetch assigned users for the selected project
        fetchAssignedUsers(valueProjectID);
        setSelectedProjectId(valueProjectID);
      }
    } else {
      const { name, value } = event.target as HTMLInputElement | HTMLTextAreaElement;
      setNewLog({ ...newLog, [name]: value });
    }
  };


  const validateInput = () => {
    //Validate the mandatory fields entered or not
    if (newLog.title.length === 0) {
      toast.error("Please enter dailylog title.")
      return false;
    }
    if (newLog.projectname.length == 0) {
      toast.error("Please select project name.")
      return false;
    }
    if (newLog.status.length === 0) {
      toast.error("Please select the dailylog status.")
      return false;
    }
    if (newLog.createdby.length === 0) {
      toast.error("Please enter created by.")
      return false;
    }
    if (newLog.assignedto.length === 0) {
      toast.error("Please select assignedto value.")
      return false;
    }
    if (newLog.createddate.length === 0) {
      toast.error("Please enter created date value.")
      return false;
    }
    if (newLog.remarks.length == 0) {
      toast.error("Please enter Remarks.")
      return false;
    }
    if (newLog.initials.length == 0) {
      toast.error("Signature is required.")
      return false;
    }
    return true
  }


  // const handleSubmit = async (event: React.FormEvent) => {
  //   event.preventDefault();
  //   try {
  //     // Send POST request to the backend to create a new daily log
  //     let response: AxiosResponse<DailyLog>;
  //     console.log('newLog:', newLog);
  //     response = await axios.post(
  //       `http://127.0.0.1:8000/dailylogs/create/`,
  //       newLog,
  //       {
  //         headers: {
  //           'Content-Type': 'multipart/form-data',
  //         },
  //       }
  //     );
  //     console.log('New daily log created:', response.data);
  //     dispatch(setSelectedLogsuman(response.data));
  //     toast.success('Dailylog created successfully')
  //     navigate('/log-details');
  //   } catch (error) {
  //     toast.error('Error creating new daily log');
  //   }
  // };



  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsSaving(true);
    try {

      newLog.attachments = selectedFiles[0]
      newLog.attachments2 = selectedFiles[1]
      newLog.attachments3 = selectedFiles[2]
      newLog.attachments4 = selectedFiles[3]
      newLog.attachments5 = selectedFiles[4]
      newLog.attachments6 = selectedFiles[5]

      let ret = validateInput()
      if (!ret) {
        setIsSaving(false);
        return
      }

      newLog.signature = signatureData;

      // Send POST request to create a new daily log
      const url_create = BASEURL + '/dailylogs/create/';
      const response = await axios.post(url_create, newLog, {
        headers: { 'Content-Type': 'multipart/form-data', },
      });

      //dispatch(setSelectedLogsuman(response.data));
      toast.success('Dailylog created successfully');

      const newid = response?.data.trackingid;
      newLog.id = newid;
      newLog.remarks = '';
      newLog.attachments = null;
      newLog.attachments2 = null;
      newLog.attachments3 = null;
      newLog.attachments4 = null;
      newLog.attachments5 = null;
      newLog.attachments6 = null;

      navigate('/log-details', { state: { logDetails: newLog, projectNamesData: projectNamesData } });

    } catch (error) {
      toast.error('Error creating new daily log');
      setIsSaving(false);
    }
  };

  const handleCancelClick = () => {
    navigate('/dailylogs')
  }


  const handleFilesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(event.target.files!) as File[]; // Type assertion for clarity

    // Filter out unique files to add
    const uniqueFilesToAdd = newFiles.filter((file) => !selectedFiles.some((selectedFile) => selectedFile.name === file.name));

    if ((uniqueFilesToAdd.length + selectedFiles.length) > 6) {
      // Display an error message or perform any other action to notify the user
      toast.error('You can only upload up to 6 files.');
      return; // Abort further processing
    }

    // Add unique files to the selected files
    setSelectedFiles((prevFiles) => [...prevFiles, ...uniqueFilesToAdd]);

  };


  const handleRemoveFile = (fileName: string) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      //    setNewLog({ ...newLog, attachments: files[0] });
    }
  };

  const handleButtonClick = (evt: any) => {
    evt.preventDefault();

    // Display the error message when the button is clicked
    if (selectedFiles.length > 5)
      toast.error("You can upload maximum of 6 files.")
    else {
      let obj = document.getElementById('fileInput');
      if (obj != null)
        obj.click();
    }
  };

  const handleClearSignature = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
      setSignatureData('');
    }
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ mt: '-80px' }}>
        <Typography variant='h6' gutterBottom>
          <Link to={'/dailylogs'} >Daily Log</Link>{ARROW} Create New
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container alignItems="center" spacing={1}>
            {DailyLogfields.map((field) => (
              // Exclude rendering "attachments" and "remarks" fields
              !['projectcode'].includes(field.name) && (
                <React.Fragment key={field.name}>
                  <Grid item xs={5} sm={6} md={3}>
                    <Typography><strong>{field.title}</strong>{['description', 'attachments'].includes(field.name) && ' (optional)'}</Typography>
                  </Grid>
                  <Grid item xs={5} sm={6} md={3}>

                    {field.type === 'dropDown' ? (
                      <Box sx={{ mt: "15px", border: '1px solid #000000' }}>

                        {field.name === "projectname" ? (
                          <Select
                            value={newLog.project_id !== null ? newLog.project_id : ''}
                            onChange={handleInputChange}
                            fullWidth
                            variant='outlined'
                            name={field.name}
                          >
                            {/* Map through options and render MenuItem for each */}
                            {projectNamesData.filter(project => project.project_status !== "Completed").map((project, index) => (
                              <MenuItem key={index} value={project.id}
                                sx={{
                                  color: '#000000',
                                  fontSize: '18px',
                                  backgroundColor: newLog.projectname === project.project_name ? '#d3d3d3' : 'inherit',
                                }}>
                                {project.project_name}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : field.name === "assignedto" ? (
                          <Select
                            value={newLog.assignedto || ""}
                            onChange={handleInputChange}
                            fullWidth
                            variant='outlined'
                            name={field.name}
                          >
                            {assignedUsers.length === 0 && (
                              <MenuItem disabled value="">
                                <em>Select a project to assign user</em>
                              </MenuItem>
                            )}
                            {assignedUsers.map((type: string) => (
                              <MenuItem
                                key={type}
                                value={type}
                                sx={{
                                  color: '#000000',
                                  fontSize: '18px',
                                  backgroundColor: newLog.assignedto === type ? '#d3d3d3' : 'inherit',
                                }}
                              >
                                {type}
                              </MenuItem>
                            ))}
                          </Select>
                        ) :
                          field.name === "status" ? (
                            <Select
                              value={newLog.status}
                              onChange={handleInputChange}
                              fullWidth
                              variant='outlined'
                              name={field.name}

                            >
                              {field.options?.map((option, index) => (
                                <MenuItem
                                  key={index}
                                  value={option}
                                  style={{
                                    color: '#000000',
                                    fontSize: '18px',
                                    backgroundColor: newLog.status === option ? '#d3d3d3' : 'inherit', // highlight color for selected item

                                  }}
                                >
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : (
                            <Select
                              value={newLog[field.name] !== null ? newLog[field.name] as string : ''}
                              onChange={handleInputChange}
                              fullWidth
                              variant='outlined'
                              name={field.name}
                            >
                              {/* Map through options and render MenuItem for each */}
                              {field.options?.map((option, index) => (
                                <MenuItem key={index} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                      </Box>
                    ) : field.name === 'createdby' ? (
                      <Box sx={{ mt: '20px' }}>
                        {newLog.createdby}
                      </Box>
                    ) : field.name === 'createddate' ? (
                      <Box sx={{ mt: '20px' }}>
                        {newLog.createddate}
                      </Box>

                    ) : field.name === 'description' ? (
                      <TextField
                        name={field.name}
                        value={newLog[field.name]}
                        onChange={handleInputChange}
                        fullWidth
                        margin='normal'
                        variant='outlined'
                        multiline
                        rows={field.height}
                      />
                    ) : field.name === 'remarks' ? (
                      <TextField
                        name={field.name}
                        value={newLog[field.name]}
                        onChange={handleInputChange}
                        fullWidth
                        margin='normal'
                        variant='outlined'
                        multiline
                        rows={field.height}
                      />
                    ) : field.name === 'attachments' ? (

<Box sx={{ mt: '15px', width: '300px' }}>
  <input
    id="fileInput"
    type="file"
    name="file"
    onChange={handleFilesChange}
    accept=".jpg, .jpeg, .png"
    multiple
    style={{ display: 'none' }}
  />
  <Button variant="contained" color="primary" onClick={handleButtonClick}>
    Browse
  </Button>

  {selectedFiles.map((file: any) => (
    <div key={file.name}>
      <Grid container spacing={0} sx={{ mt: 1 }}>
        {/* File name section */}
        <Grid item md={6} xs={12} sx={{ wordWrap: 'break-word' }}>
          {/* Ensuring the file name wraps properly */}
          <span style={{ display: 'block', overflowWrap: 'break-word' }}>
            {file.name}
          </span>
        </Grid>

        {/* Remove button section */}
        <Grid item md={3} xs={12}>
          <Button
            color="error"
            variant="text"
            onClick={() => handleRemoveFile(file.name)}
            sx={{ mt: { xs: 1, md: 0 } }} // Add margin-top on small screens to avoid overlap
          >
            Remove
          </Button>
        </Grid>
      </Grid>
    </div>
  ))}
</Box>

                    ) : field.name === 'signature' ? (


                      <div style={{
                        display: 'flex', flexDirection: 'column', border: '1px solid #ccc',
                        paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 0,
                      }}> {/* Wrap Sign in flex container with column layout and border */}

                        <TextField
                          name={'initials'} type={'text'} value={newLog['initials']}
                          onChange={handleInputChange}
                          fullWidth margin='dense' variant='outlined'
                          sx={{
                            ...AUTOFILL_STYLES(theme),
                          }}
                        />


                        <span style={{
                          fontFamily: SIGN_FONT, minHeight: '50px', maxWidth: '100%', whiteSpace: 'pre-wrap',
                          fontSize: FONT_SIZE, border: '2px solid #ccc', padding: 5
                        }}>
                          {newLog['initials']}
                        </span>
                      </div>
                    ) : (
                      <TextField
                        name={field.name}
                        type={
                          field.type === 'date'
                            ? 'date'
                            : field.type === 'dropzone'
                              ? 'dropzone'
                              : 'text'
                        }
                        value={newLog[field.name]}
                        onChange={handleInputChange}
                        fullWidth
                        margin='normal'
                        variant='outlined'
                        sx={{
                          ...AUTOFILL_STYLES(theme),
                        }}
                      />
                    )}

                  </Grid>
                </React.Fragment>
              )

            ))}


          </Grid>


          <Box sx={{ mt: '50px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button type='submit' variant='contained' color='primary'
              sx={{ marginRight: '20px', width: '75px', '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
              disabled={isSaving}
            >
              Save
            </Button>
            <Button
              variant='contained'
              onClick={handleCancelClick}
              sx={{ width: '75px' }}
            >
              Cancel
            </Button>

          </Box>
        </form>
        <FloatingButton />
      </Box>
    </ThemeProvider >
  );
};

export default CreateNewDailyLogPage;